import React from "react";
import { VariantProps } from "class-variance-authority";

import { button, ButtonBody } from "components/Button/Button";
import { Link, LinkProps } from "components/Link/Link";

import { Override } from "types/utils";

import "./Button.scss";

export type LinkButtonPropsCustom = {
    iconLeft?: React.ReactNode;
    iconRight?: React.ReactNode;
    connectedLeft?: boolean;
    connectedRight?: boolean;
};

type MergedLinkButtonProps = Override<LinkProps, LinkButtonPropsCustom>;

export type LinkButtonProps = React.PropsWithChildren<MergedLinkButtonProps> &
    VariantProps<typeof button>;

export const LinkButton = React.forwardRef<HTMLAnchorElement, LinkButtonProps>(
    (
        {
            children,
            variation = "primary",
            size = "md",
            iconLeft,
            iconRight,
            connectedLeft,
            connectedRight,
            className,
            ...props
        },
        ref
    ) => {
        const classes = button({
            className,
            variation,
            size,
            connectedLeft,
            connectedRight,
        });

        return (
            <Link {...props} ref={ref} className={classes} styled={false}>
                <ButtonBody iconLeft={iconLeft} iconRight={iconRight}>
                    {children}
                </ButtonBody>
            </Link>
        );
    }
);
